document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.trade-form');
    const form = document.getElementById('trade-form');
    const feedbackEl = document.getElementById('trade-form-feedback');
    if (!form || !section) return;

    const inputs = form.querySelectorAll('input, select');
    const registerUrl = window.tradeCreditRegisterUrl;
    const refreshUrl = window.tradeCreditApiUrl;
    if (!registerUrl || !refreshUrl) return;

    function showFeedback(text, type) {
        if (!feedbackEl) return;
        feedbackEl.textContent = text;
        feedbackEl.className = 'trade-form__feedback trade-form__feedback--' + type;
        feedbackEl.hidden = false;
    }

    function hideFeedback() {
        if (feedbackEl) {
            feedbackEl.hidden = true;
            feedbackEl.textContent = '';
            feedbackEl.className = 'trade-form__feedback';
        }
    }

    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        hideFeedback();

        if (!form.checkValidity()) {
            form.reportValidity();
            const firstInvalid = form.querySelector(':invalid');
            if (firstInvalid) {
                firstInvalid.focus();
                window.scrollTo({
                    top: firstInvalid.getBoundingClientRect().top + window.scrollY - 100,
                    behavior: 'smooth',
                });
            }
            return;
        }

        const formData = new FormData(form);

        if (formData.get('street_address') && formData.get('street_address_2')) {
            formData.set('street_address', formData.get('street_address') + ', ' + formData.get('street_address_2'));
            formData.delete('street_address_2');
        }

        section.classList.add('trade-form--loading');

        try {
            await fetchRequest(registerUrl, 'POST', Object.fromEntries(formData));
            showFeedback('You have been registered. Refreshing available credits...', 'success');

            await fetchRequest(refreshUrl, 'POST', {
                shopifyCustomerId: formData.get('shopify_customer_id'),
            });

            window.location.reload();
        } catch (error) {
            showFeedback(error.websiteMessage || 'An error occurred. Please try again.', 'error');
            console.error(error.message);
        } finally {
            section.classList.remove('trade-form--loading');
        }
    });

    inputs.forEach(function(input) {
        input.addEventListener('input', hideFeedback);
    });
});

async function fetchRequest(url, method, body) {
    const response = await fetch(url, {
        method: method,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        const data = await response.json().catch(function() { return {}; });
        throw {
            message: data.error,
            websiteMessage: data.websiteMessage,
        };
    }

    return response.json();
}
